/*  MUI  */
import { Box, List } from '@mui/material';
import { SessionHelper } from 'application/Shared/Helpers';
import { Session } from 'application/Shared/types/session';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IconForSidebarListItem } from './SidebarIcons';
import { SidebarListItem } from './SidebarListItem';

/**
 * Renders a home link in the sidebar navigation.
 * Only displays if the user has completed configuration and accepted Terms of Service.
 * @param {Object} props - Component props
 * @param {Session} props.session - User session object containing configuration and ToS status
 * @returns {JSX.Element} Sidebar home link component
 */
export const SidebarHomeLink = ({
    session
}: {
    session: Session;
}): JSX.Element => {
    const { t } = useTranslation();
    const sessionHelper = new SessionHelper(session);
    const user = sessionHelper.getUser();
    const { configured, tos } = user;

    return (
        <List component="nav" aria-labelledby="nested-list-subheader">
            {/*
                If the user hasn't configured their user, or accept the ToS,
                we don't want to show any sidebar links that would let them bypass this.
            */}
            {configured && tos && (
                <Box
                    data-testid="sidebarHomeLink"
                    data-trackid="sidebarHomeLink"
                    mt="8px"
                >
                    <SidebarListItem
                        icon={<IconForSidebarListItem src="Apps" />}
                        id="home_dashboard"
                        name={t('Common.dashboard')}
                        route="/home"
                    />
                </Box>
            )}
        </List>
    );
};
